// Full liability waiver text for KRYOTEKS.
export const BUSINESS = {
  name: 'KRYOTEKS',
  address: '2500 Polk St., San Francisco, CA 94109',
  phone: '510-827-1848',
  email: 'kryoteks@gmail.com',
  appointmentOnly: true,
};

export const WAIVER_TEXT = `RELEASE OF LIABILITY, WAIVER OF CLAIMS, ASSUMPTION OF RISK,
AND INDEMNITY AGREEMENT

By signing this document, you agree to the following terms and acknowledgments
regarding services provided by KRYOTEKS, located at 2500 Polk St.,
San Francisco, CA 94109, phone 510-827-1848, email kryoteks@gmail.com
(hereafter the "Provider"). KRYOTEKS operates by appointment only.

1. VOLUNTARY PARTICIPATION
I acknowledge that my participation in localized cryotherapy (aesthetic and
orthopedic) and any related services (collectively, the "Services") is
entirely voluntary. I am choosing to participate at my own risk and free will.

2. ASSUMPTION OF RISK
I understand that the Services involve exposure to extremely cold temperatures
(as low as -220 F / -140 C) and that there are inherent risks, including but
not limited to: frostbite, cold burns, skin discoloration, temporary redness,
dizziness, fluctuations in blood pressure, allergic reactions, and, in rare
cases, more serious injury. I voluntarily and knowingly assume all such risks.

3. MEDICAL CONTRAINDICATIONS
I certify that I do NOT have any of the following conditions, and I understand
that if I do, I should NOT participate in the Services without written medical
clearance from a licensed physician:
   -  Pregnancy
   -  Raynaud's Syndrome or cold-related disorders
   -  Uncontrolled high blood pressure (over 180/100)
   -  Recent heart attack, unstable angina, or heart failure
   -  Pacemaker or other implanted electronic device
   -  Peripheral arterial disease or deep vein thrombosis
   -  Cold allergy, cold urticaria, or cryoglobulinemia
   -  Seizure disorders
   -  Severe anemia
   -  Open wounds, ulcers, or active skin infections in the treatment area
   -  Any acute infection or fever
   -  Under the influence of alcohol or drugs

I agree to inform the Provider of any medical condition, medication, or change
in health that could affect my safety before each session.

4. INSTRUCTIONS AND CONDUCT
I agree to follow all instructions given by the Provider's staff before,
during, and after each session. This includes wearing all protective gear
provided (gloves, socks, slippers, ear/face coverings), keeping skin dry, and
promptly notifying staff of any discomfort. I understand that failure to follow
instructions may increase my risk of injury.

5. NO MEDICAL ADVICE
I acknowledge that the Services are NOT a substitute for medical treatment,
diagnosis, or advice. The Provider and its staff are not medical professionals
and make no representations or warranties regarding the therapeutic or medical
benefits of the Services.

6. PHOTOGRAPHY AND RECORDS
I consent to the Provider maintaining a digital record of this signed waiver
and my contact information for the purposes of session tracking, safety, and
compliance. I may request a copy of my signed waiver at any time.

7. RELEASE AND INDEMNIFICATION
I, on behalf of myself, my heirs, family, and legal representatives, hereby
release, waive, discharge, and covenant not to sue KRYOTEKS, its
owners, employees, contractors, and agents from any and all liability, claims,
demands, actions, and causes of action arising from my participation in the
Services, including any negligence on the part of the Provider, to the fullest
extent permitted by California law.

8. GOVERNING LAW
This agreement shall be governed by the laws of the State of California.

I HAVE READ THIS AGREEMENT CAREFULLY, UNDERSTAND ITS CONTENTS, AND SIGN IT OF
MY OWN FREE WILL.`;
